module.exports = __webpack_public_path__ + "img/39_59.99ef279c.png";